import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import toast from 'react-hot-toast';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Get Wallet
export const getWallet = createAsyncThunk(
  'wallet/get',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const config = {
        headers: { Authorization: `Bearer ${auth.token}` }
      };
      const response = await axios.get(`${API_URL}/wallet`, config);
      return response.data.wallet;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

// Get Transactions
export const getTransactions = createAsyncThunk(
  'wallet/getTransactions',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const config = {
        headers: { Authorization: `Bearer ${auth.token}` }
      };
      const response = await axios.get(`${API_URL}/wallet/transactions`, config);
      return response.data.transactions;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

// Add Money
export const addMoney = createAsyncThunk(
  'wallet/addMoney',
  async (formData, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${auth.token}`
        }
      };
      const response = await axios.post(`${API_URL}/wallet/add-money`, formData, config);
      toast.success('Money added request submitted');
      return response.data.wallet;
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to add money');
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

// Withdraw Money
export const withdrawMoney = createAsyncThunk(
  'wallet/withdraw',
  async ({ amount, bankDetails }, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const config = {
        headers: { Authorization: `Bearer ${auth.token}` }
      };
      const response = await axios.post(`${API_URL}/wallet/withdraw`, { amount, bankDetails }, config);
      toast.success('Withdrawal request submitted');
      return response.data.wallet;
    } catch (error) {
      toast.error(error.response?.data?.message || 'Withdrawal failed');
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

const walletSlice = createSlice({
  name: 'wallet',
  initialState: {
    wallet: null,
    transactions: [],
    loading: false,
    error: null,
    balance: 0,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWallet.pending, (state) => {
        state.loading = true;
      })
      .addCase(getWallet.fulfilled, (state, action) => {
        state.loading = false;
        state.wallet = action.payload;
        state.balance = action.payload?.balance || 0;
      })
      .addCase(getWallet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getTransactions.fulfilled, (state, action) => {
        state.transactions = action.payload;
      })
      .addCase(addMoney.fulfilled, (state, action) => {
        state.wallet = action.payload;
        state.balance = action.payload?.balance || 0;
      })
      .addCase(withdrawMoney.fulfilled, (state, action) => {
        state.wallet = action.payload;
        state.balance = action.payload?.balance || 0;
      });
  },
});

export const { clearError } = walletSlice.actions;
export default walletSlice.reducer;